import { useStyles } from '@webapps/styles';
import { resolvePath } from '@webapps/utils';
import PropTypes from 'prop-types';
import { TextFieldPx } from '..';

const FormikTextInput = ({
  children,
  formik: { errors, handleChange, touched, values },
  name,
  borderRadius,
  onChange,
  completed,
  showError = true,
  validation = {},
  placeholder = '',
  value: providedValue, // Destructure the value prop
  ...props
}) => {
  const { classes } = useStyles(styles);

  const textFormatter = (value, validation) => {
    if (!value || !validation?.format || !Array.isArray(validation.format)) return value || '';
    const cleanValue = value.replace(/\s/g, '');
    const parts = [];
    let index = 0;
    for (const length of validation.format) {
      if (index < cleanValue.length) {
        parts.push(cleanValue.slice(index, index + length));
        index += length;
      }
    }
    return parts.join(' ');
  };

  // Use the provided value if passed, otherwise fall back to resolvePath
  const rawValue = providedValue !== undefined ? providedValue : resolvePath(values, name, '');
  const displayValue = validation?.format ? textFormatter(rawValue, validation) : rawValue;

  return (
    <TextFieldPx
      error={!!resolvePath(touched, name, '') && showError && !!resolvePath(errors, name, '')}
      helperText={resolvePath(touched, name, '') && showError && (validation?.message || resolvePath(errors, name, ''))}
      id={name}
      name={name}
      borderRadius={borderRadius}
      placeholder={placeholder}
      onChange={(e) => {
        let value = validation?.format ? e.target.value.replace(/\s/g, '') : e.target.value;
        if (validation?.numeric) {
          value = value.replace(/\D/g, '');
        }
        if (validation?.requiredLength) {
          value = value.slice(0, validation.requiredLength);
        }
        if (onChange) {
          onChange({ ...e, target: { ...e.target, value } });
        } else {
          handleChange({ ...e, target: { ...e.target, name, value } });
        }
      }}
      value={displayValue}
      completed={completed}
      {...props}
    >
      {children}
    </TextFieldPx>
  );
};

const styles = () => ({});

FormikTextInput.propTypes = {
  field: PropTypes.elementType,
  name: PropTypes.string,
  formik: PropTypes.object,
  children: PropTypes.node,
  onChange: PropTypes.func,
  completed: PropTypes.bool,
  showError: PropTypes.bool,
  value: PropTypes.any, // Add value to propTypes
};

export default FormikTextInput;